var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "category-dialog" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "分类管理",
            visible: _vm.dialogVisible,
            width: "552px",
            modal: true,
            scrollable: "body",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.resetEditing,
          },
        },
        [
          _c(
            "transition-group",
            {
              staticClass: "category-table-wrapper",
              attrs: { name: "list", tag: "div" },
            },
            [
              _c(
                "el-table",
                {
                  key: "table",
                  staticClass: "category-table",
                  staticStyle: { width: "100%", "margin-bottom": "20px" },
                  attrs: {
                    data: _vm.categoryList,
                    "row-key": "id",
                    "show-header": false,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "分类名称", "min-width": "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.editing
                              ? _c(
                                  "div",
                                  { staticClass: "edit-form" },
                                  [
                                    _c("el-input", {
                                      ref: "editInput",
                                      staticClass: "edit-input",
                                      attrs: {
                                        maxlength: "10",
                                        "show-word-limit": "",
                                        size: "small",
                                      },
                                      on: {
                                        keyup: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          return _vm.saveEdit(scope.row)
                                        },
                                      },
                                      model: {
                                        value: scope.row.tempName,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "tempName", $$v)
                                        },
                                        expression: "scope.row.tempName",
                                      },
                                    }),
                                    _c("div", { staticClass: "form-actions" }, [
                                      _c(
                                        "div",
                                        {
                                          class: {
                                            disabled:
                                              !scope.row.tempName.trim(),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.saveEdit(scope.row)
                                            },
                                          },
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("@/assets/img/announcement/confirm.png"),
                                              alt: "",
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.cancelEdit(scope.row)
                                            },
                                          },
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("@/assets/img/announcement/cancel.png"),
                                              alt: "",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              : _c("span", [
                                  _vm._v(_vm._s(scope.row.categoryName)),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            !scope.row.editing
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "action-group" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          class: {
                                            animating:
                                              scope.row.animating === "top",
                                          },
                                          staticStyle: { cursor: "pointer" },
                                          attrs: {
                                            size: "mini",
                                            disabled: scope.$index === 0,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.moveCategory(
                                                scope.row,
                                                "top"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("img", {
                                            style: {
                                              opacity:
                                                scope.$index === 0 ? 0.3 : 1,
                                            },
                                            attrs: {
                                              src: require("@/assets/img/announcement/top.png"),
                                              alt: "",
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          class: {
                                            animating:
                                              scope.row.animating === "up",
                                          },
                                          staticStyle: { cursor: "pointer" },
                                          attrs: {
                                            size: "mini",
                                            disabled:
                                              scope.$index ===
                                              _vm.categoryList.length - 1,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.moveCategory(
                                                scope.row,
                                                "up"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("img", {
                                            style: {
                                              opacity:
                                                scope.$index === 0 ? 0.3 : 1,
                                            },
                                            attrs: {
                                              src: require("@/assets/img/announcement/up.png"),
                                              alt: "",
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          class: {
                                            animating:
                                              scope.row.animating === "down",
                                          },
                                          staticStyle: { cursor: "pointer" },
                                          attrs: {
                                            size: "mini",
                                            disabled: scope.$index === 0,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.moveCategory(
                                                scope.row,
                                                "down"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("img", {
                                            style: {
                                              opacity:
                                                scope.$index ===
                                                _vm.categoryList.length - 1
                                                  ? 0.3
                                                  : 1,
                                            },
                                            attrs: {
                                              src: require("@/assets/img/announcement/down.png"),
                                              alt: "",
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          class: {
                                            animating:
                                              scope.row.animating === "bottom",
                                          },
                                          staticStyle: { cursor: "pointer" },
                                          attrs: {
                                            size: "mini",
                                            disabled:
                                              scope.$index ===
                                              _vm.categoryList.length - 1,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.moveCategory(
                                                scope.row,
                                                "bottom"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("img", {
                                            style: {
                                              opacity:
                                                scope.$index ===
                                                _vm.categoryList.length - 1
                                                  ? 0.3
                                                  : 1,
                                            },
                                            attrs: {
                                              src: require("@/assets/img/announcement/bottom.png"),
                                              alt: "",
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "el-dropdown",
                                        {
                                          attrs: { trigger: "click" },
                                          on: {
                                            command: (command) =>
                                              _vm.handleMore(
                                                scope.row,
                                                command
                                              ),
                                          },
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("@/assets/img/announcement/more.png"),
                                              alt: "",
                                            },
                                          }),
                                          _c(
                                            "el-dropdown-menu",
                                            {
                                              attrs: { slot: "dropdown" },
                                              slot: "dropdown",
                                            },
                                            [
                                              _c(
                                                "el-dropdown-item",
                                                {
                                                  staticClass: "custom-item",
                                                  attrs: { command: "edit" },
                                                },
                                                [_vm._v("重命名")]
                                              ),
                                              _c(
                                                "el-dropdown-item",
                                                {
                                                  staticClass: "custom-item",
                                                  attrs: { command: "delete" },
                                                },
                                                [_vm._v("删除")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "add-category" }, [
            !_vm.isAdding
              ? _c(
                  "div",
                  {
                    staticClass: "add-trigger",
                    staticStyle: { cursor: "pointer" },
                    on: { click: _vm.startAdding },
                  },
                  [
                    _c("span", [_vm._v("新增分类")]),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/announcement/add.png"),
                        alt: "",
                      },
                    }),
                  ]
                )
              : _c(
                  "div",
                  { staticClass: "add-form" },
                  [
                    _c("el-input", {
                      ref: "addInput",
                      attrs: {
                        placeholder: "请输入分类名称",
                        clearable: "",
                        size: "small",
                        maxlength: "10",
                        "show-word-limit": "",
                      },
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.confirmAdd.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.newCategoryName,
                        callback: function ($$v) {
                          _vm.newCategoryName = $$v
                        },
                        expression: "newCategoryName",
                      },
                    }),
                    _c("div", { staticClass: "form-actions" }, [
                      _c(
                        "div",
                        {
                          staticClass: "confirm-btn",
                          attrs: { disabled: !_vm.newCategoryName.trim() },
                          on: { click: _vm.confirmAdd },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/announcement/confirm.png"),
                              alt: "",
                            },
                          }),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "cancel-btn",
                          on: { click: _vm.cancelAdd },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/announcement/cancel.png"),
                              alt: "",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
          ]),
          _vm.showOperationHint
            ? _c(
                "div",
                { staticClass: "operation-hint", class: _vm.hintClass },
                [_vm._v(" " + _vm._s(_vm.operationHintText) + " ")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }